import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function getListVehiculo(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            API_BASE_URL + "/vehiculo/list-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.idActivo,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("getListVehiculo err");
        console.log(err);
        return [];
    }
}

export async function createVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/vehiculo/create-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/vehiculo/disable-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/vehiculo/enable-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enableVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updateVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/vehiculo/update-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updateVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListVehiculoCombo(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            API_BASE_URL + "/vehiculo/list-vehiculo-combo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            data = data.map((item) => {
                return {
                    value: item.id,
                    label: item.idActivo,
                };
            });

        }
        return data;
    } catch (err) {
        console.log("obtenerListVehiculoCombo err");
        console.log(err);
        return [];
    }
}

export async function obtenerInfoVehiculo(obj) {
    try {
        let data = null;
        const { code, body } = await fetch(
            API_BASE_URL + "/vehiculo/obtener-info-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerInfoVehiculo err");
        console.log(err);
        return null;
    }
}

export async function obtenerAllInfoVehiculo(obj) {
    try {
        let data = null;
        const { code, body } = await fetch(
            API_BASE_URL + "/vehiculo/all-info-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data = body[0];
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerAllInfoVehiculo err");
        console.log(err);
        return null;
    }
}

export async function createVehiculoFromExcel(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/vehiculo/create-vehiculo-from-excel",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createVehiculoFromExcel err");
        console.log(err);
        return { error: true, message: err };
    }
}